import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button';
import {AddressFormat} from 'types/address';

type ChangeAddressFormatProps = {
    format?: AddressFormat;
    isSelected: boolean;
    onClick: () => void;
};

const ChangeAddressFormat: FC<ChangeAddressFormatProps> = ({
    format,
    isSelected,
    onClick,
}) => {
    const {t} = useTranslation('Profile.Setup.Preview');

    return (
        <div
            className={clsx(
                'col-span-12 mt-2 flex border-t p-2',
                isSelected ? 'border-blue-100 bg-blue-50' : 'border-grey-200',
            )}
        >
            <Button
                className="flex-1 border-none text-left text-sm text-green-700"
                kind="custom"
                onClick={onClick}
            >
                {t(
                    `senderInformation.${
                        format === 'jp_default' ? 'ja' : 'en'
                    }ChangeTo`,
                )}
            </Button>
        </div>
    );
};

export default ChangeAddressFormat;
